import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ScrollLeftButton, ScrollRightButton } from 'src/domains/layouts/shared/ScrollButtons.style';

import { withConfig } from 'src/withConfig';

interface StreamIframeWrapperRMGPropsType {
    streamIsInViewport: boolean;
    variant: DefaultComponentVariantType | null;
}

const setSectionRaceCard = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium} 0;
            @media ${theme.star.mediaQuery.tablet} {
                padding: ${theme.star.padding.medium};
            }
        `;
    }
    return css``;
};

export const SectionRaceCard = withConfig(theme => styled('div', { label: 'SectionRaceCard' })<StreamIframeWrapperRMGPropsType>`
    position: ${({ streamIsInViewport }): string => streamIsInViewport === true ? 'relative' : 'static'};
    ${({ variant }): SerializedStyles => setSectionRaceCard(variant, theme)}
`);

interface FiltersWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const FiltersWrapper = withConfig(theme => styled('div', { label: 'FiltersWrapper' })<FiltersWrapperPropsType>`
    background-color: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'transparent': theme.star.filtersColors.wrapper.bgColor};
    padding: 8px 0 8px 56px;
    position: relative;
`);

export const FiltersBackButton = withConfig(theme => styled('button', { label: 'FiltersBackButton' })`
    align-items: center;
    background-color: transparent;
    border: none;
    color: ${theme.star.raceCard.filters.name.txtColor};
    cursor: pointer;
    display: inline-flex;
    height: 100%;
    justify-content: center;
    left: 0;
    padding: 0;
    padding: 14px;
    position: absolute;
    top: 0;
    width: 48px;
`);

export const TabsWrapper = styled('div', { label: 'TabsWrapper' })`
    position: relative;
`;

export const ScrollLeft = styled(ScrollLeftButton, { label: 'ScrollLeft' })`
    top: 12px;
    margin: 0;
`;

export const ScrollRight = styled(ScrollRightButton, { label: 'ScrollRight' })`
    top: 12px;
    margin: 0;
`;
